import {
  methods
} from "./methods.js"
import {
  filters
} from "./filters.js"

export default {
  install: function(Vue, opt) {
    Vue.mixin({
      methods: methods,
      filters: filters
    })
    /*删除无效属性*/
    Vue.$deletePropertyInvalid = function(obj, value_delete) {
      if (obj != null) {
        for (var key in obj) {
          if (obj[key] === null) {
            delete obj[key];
          }
        }
        if (value_delete !== null && value_delete !== undefined) {
          for (var key in obj) {
            if (obj[key] == value_delete) {
              delete obj[key];
            }
          }
        }
      }
      return obj;
    }
    /*正则校验*/
    Vue.prototype.$testRegExp = function(re, s, msg) {
      if (s == null || this.trim(s) == "") {
        this.$vux.toast.show({
          text: "请输入" + msg
        })
      } else {
        s = this.trim(s);
        if (re.test(s)) {
          return true;
        } else {
          if (msg != null) {
            this.$vux.toast.show({
              text: "请输入正确格式的" + msg
            })
          }
          return false;
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./static/utils/util.js